import React from 'react';
import Parser from 'html-react-parser';
import { R } from '@core/utils/r';
import { WithTooltip } from '@modules/common';
import { GlossaryLanguages, GlossaryStepResponse } from '@business/entities/glossary';
import { HTMLService } from '../html_service';

export function getGlossaryContent(htmlContent: string) {
  return Parser(htmlContent, {
    replace: domNode => {
      if (R.get(domNode, 'attribs.class', '').includes('glossary-word')) {
        const tooltip = R.get(domNode, 'attribs.data-definition');
        const word = R.get(domNode, 'children[0].data');
        return (
          <WithTooltip
            tooltip={
              <span>
                <h6 className="text-white mb-0" style={{ fontWeight: 700 }}>
                  {word}
                </h6>
                <br className="m-0" />
                {tooltip}
              </span>
            }
            placement="right"
          >
            <span style={{ borderBottom: '3px  solid lightgray', cursor: 'pointer' }}>{word}</span>
          </WithTooltip>
        );
      }
      return domNode;
    },
  });
}

// export function getGlossaryContent(paragraph: string, words: GlossaryStepResponse[]) {
//   if (words.length === 0) {
//     return <div className="hca-content" style={{ fontSize: 20 }} dangerouslySetInnerHTML={{ __html: paragraph }} />;
//   }

//   // Sort words by length to avoid nested replacements
//   words.sort((a, b) => b.definitionWord.length - a.definitionWord.length);

//   // Create a single regex pattern for all words
//   const regex = new RegExp(`(${words.map(word => word.definitionWord).join('|')})`, 'gi');
//   const parts = paragraph.split(regex);

//   const updatedParagraph = parts.map((part: any, index: number) => {
//     const matchedWord = words.find(word => word.definitionWord.toLowerCase() === part.toLowerCase());

//     if (matchedWord) {
//       return (
//         <WithTooltip
//           key={`${index}-${part}`} // Ensure unique key for React
//           tooltip={
//             <span>
//               <h6 className="text-white mb-0" style={{ fontWeight: 700 }}>
//                 {matchedWord.definitionWord}
//               </h6>
//               <br className="m-0" />
//               {matchedWord.definition}
//             </span>
//           }
//           placement="right"
//         >
//           <span style={{ borderBottom: '3px solid lightgray', cursor: 'pointer' }}>{part}</span>
//         </WithTooltip>
//       );
//     } else {
//       return HTMLService.toReact(part); // Preserve the original HTML structure
//     }
//   });

//   console.log(updatedParagraph);

//   return (
//     <div className="hca-content" style={{ fontSize: 20 }}>
//       {updatedParagraph}
//     </div>
//   );
// }

export function getAllGlossaryLanguages() {
  return [
    GlossaryLanguages.all,
    GlossaryLanguages.english,
    GlossaryLanguages.chinese,
    GlossaryLanguages.hungarian,
    GlossaryLanguages.french,
    GlossaryLanguages.russian,
    GlossaryLanguages.spanish,
    GlossaryLanguages.german,
    GlossaryLanguages.italian,
    GlossaryLanguages.dutch,
    GlossaryLanguages.swedish,
    GlossaryLanguages.hebrew,
    GlossaryLanguages.slovak,
    GlossaryLanguages.japanese,
    GlossaryLanguages.czech,
    GlossaryLanguages.bulgarian,
  ];
}

export function getGlossaryLanguageLabel(language: GlossaryLanguages) {
  switch (language) {
    case GlossaryLanguages.all:
      return 'All';
    case GlossaryLanguages.english:
      return 'English';
    case GlossaryLanguages.chinese:
      return 'Chinese';
    case GlossaryLanguages.hungarian:
      return 'Hungarian';
    case GlossaryLanguages.french:
      return 'French';
    case GlossaryLanguages.russian:
      return 'Russian';
    case GlossaryLanguages.spanish:
      return 'Latam Spanish';
    case GlossaryLanguages.german:
      return 'German';
    case GlossaryLanguages.italian:
      return 'Italian';
    case GlossaryLanguages.dutch:
      return 'Dutch';
    case GlossaryLanguages.swedish:
      return 'Swedish';
    case GlossaryLanguages.hebrew:
      return 'Hebrew';
    case GlossaryLanguages.slovak:
      return 'Slovak';
    case GlossaryLanguages.japanese:
      return 'Japanese';
    case GlossaryLanguages.czech:
      return 'Czech';
    case GlossaryLanguages.bulgarian:
      return 'Bulgarian';
  }
}

export function getGlossaryLanguageItems() {
  return getAllGlossaryLanguages().map(language => ({
    value: language,
    label: getGlossaryLanguageLabel(language),
  }));
}
